const PatientGalleryImages = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/patient/Images");
const PatientGalleryAudios = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/patient/ComingSoon");
const PatientGalleryVideos = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/patient/ComingSoon");
const PatientGalleryPDFs = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/patient/ComingSoon");

export default [{
        path: "images",
        name: "dashboard.patient.gallery.images",
        component: PatientGalleryImages
    },
    {
        path: "audios",
        name: "dashboard.patient.gallery.audios",
        component: PatientGalleryAudios
    },
    {
        path: "videos",
        name: "dashboard.patient.gallery.videos",
        component: PatientGalleryVideos
    },
    {
        path: "pdf",
        name: "dashboard.patient.gallery.pdfs",
        component: PatientGalleryPDFs
    }
];